import { render, staticRenderFns } from "./CataListYearModal.vue?vue&type=template&id=650790d5&scoped=true&"
import script from "./CataListYearModal.vue?vue&type=script&lang=js&"
export * from "./CataListYearModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650790d5",
  null
  
)

export default component.exports